import http, { url } from '../../../http'

const API_URL = "coexistence-member"

class CandidatesCommitteeAPI {

  async saveCandidate(candidate) {
    const response = await http(`${API_URL}/save`, 'POST', candidate)
    return response
  }

  async save(members) {
    const response = await http(`${API_URL}/multi-save`, 'POST', {
      members: members
    })
    return response
  }

  async updateCandidate(candidateID, candidate) {
    const response = await http(`${API_URL}/update/${candidateID}`, 'PUT', candidate)
    return response
  }

  async getAllPossibleCandidates(companyID) {
    const { coexistence_committee } = await http(`${API_URL}/show/${companyID}`, 'GET')
    return coexistence_committee || null
  }

}

export default new CandidatesCommitteeAPI()